import Vue from 'vue'
import Router from 'vue-router'
import IndexRoom from '@/pages/IndexRoom'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      redirect: '/health' // 將根路徑重定向到 /health
    },
    {
      path: '/:projectId',
      name: 'IndexRoom',
      component: IndexRoom,
      meta: {
        title: ''
      }
    },
    {
      path: '/:projectId/:customStyle',
      name: 'IndexRoom1',
      component: IndexRoom,
      meta: {
        title: ''
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js